export default {
  BusinessPurchaseBasics: {
    name: '名称',
    code: '编码',
    value: '值',
    type: '类型'
  }
};
